import React, { useEffect, useState } from "react";
import DashboardNormal from "./dashboardNormal";
import DashboardChart from "./DashboardChart";
import { useHistory } from "react-router-dom";

const DashboardPanel = () => {
  const history = useHistory();
  const [viewMode, setViewMode] = useState("chart");

  useEffect(() => {
    const userPreference = localStorage.getItem("dashboardView");
    if (userPreference === "normal") {
      setViewMode("normal");
    }

    const showSubscription = JSON.parse(localStorage.getItem("showSubscription"));
    if (showSubscription) {
      let _UserSession = localStorage.getItem("vs_UserSession");
      if (_UserSession != undefined || _UserSession != null) {
        _UserSession = JSON.parse(_UserSession);
        if (_UserSession.subscriptionStatus !== "active") {
          history.push("/business/choosePlan");
          localStorage.setItem("showSubscription", JSON.stringify(false));
        }
      }
    }
  }, []);

  const handleViewChange = (mode) => {
    setViewMode(mode);
    localStorage.setItem("dashboardView", mode);
  };

  return (
    <div style={styles.dashboardContainer}>
      {viewMode === "normal" && (
        <div style={styles.normalTopBar}>
          <div style={styles.segmented}>
            <button
              type="button"
              style={styles.segmentedBtn}
              onClick={() => handleViewChange("chart")}
            >
              <i className="si si-pie-chart" style={{ marginRight: 6 }}></i>
              Chart
            </button>
            <button
              type="button"
              style={{ ...styles.segmentedBtn, ...styles.segmentedBtnActive }}
              onClick={() => handleViewChange("normal")}
            >
              <i className="si si-list" style={{ marginRight: 6 }}></i>
              Normal
            </button>
          </div>
        </div>
      )}

      {viewMode === "normal" ? (
        <DashboardNormal viewMode={viewMode} onViewChange={handleViewChange} />
      ) : (
        <DashboardChart viewMode={viewMode} onViewChange={handleViewChange} />
      )}
    </div>
  );
};

export default DashboardPanel;

const styles = {
  dashboardContainer: {
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    backgroundColor: "#f4f6fb",
    minHeight: "100vh",
  },
  normalTopBar: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "20px 28px 0",
  },
  segmented: {
    display: "inline-flex",
    padding: "4px",
    backgroundColor: "#f1f5f9",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
  },
  segmentedBtn: {
    border: "none",
    background: "transparent",
    padding: "8px 16px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#64748b",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.15s ease",
  },
  segmentedBtnActive: {
    backgroundColor: "#ffffff",
    color: "#2563eb",
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.08)",
  },
};
